import uniqBy from 'lodash/uniqBy'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import type { Cycle } from 'modules/enps/store/models/AnalyticResult'
import AnalyticResult from 'modules/enps/store/models/AnalyticResult'

export class AnalyticResults extends Collection<AnalyticResult> {
  constructor(attrs = []) {
    super(attrs)
    makeObservable(this, {
      numeric: computed,
      cycles: computed,
    })
  }

  get cacheKey(): string {
    return 'analyticResults'
  }

  model() {
    return AnalyticResult
  }

  get numeric(): AnalyticResult[] {
    return this.filter((model) => {
      return model.numericQuestions.size > 0
    })
  }

  get cycles(): Cycle[] {
    return uniqBy(
      this.models.flatMap((model) => Array.from(model.cycles)),
      (cycle: Cycle) => JSON.stringify(cycle)
    )
  }
}
